import { FGM } from "../brand";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-black border-t border-white/10 overflow-hidden"
        >
            <div className="fgm-stripe-divider w-full" />

            <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-4 mb-6">
                            <img src={FGM.logos.white} alt="FGM" className="h-12 w-12"  loading="lazy" decoding="async" />
                            <div>
                                <div className="font-display text-2xl tracking-[0.2em] text-white">
                                    FGM APPAREL
                                </div>
                                <div className="text-xs tracking-[0.3em] text-zinc-500 font-display uppercase">
                                    Focus · Grind · Motivate
                                </div>
                            </div>
                        </div>
                        <p className="text-zinc-400 max-w-md leading-relaxed">
                            For athletes, creators, and the relentless. Apparel rooted in
                            strength, elevated by modern design.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="fgm-label">Explore</div>
                        <ul className="space-y-3">
                            {[
                                ["Story", "#manifesto"],
                                ["Lookbook", "#lookbook"],
                                ["Ambassador", "#ambassador"],
                                ["Newsletter", "#newsletter"],
                            ].map(([label, href]) => (
                                <li key={label}>
                                    <a href={href} data-testid={`footer-link-${label.toLowerCase()}`} className="nav-link">
                                        {label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="fgm-label">Follow</div>
                        <ul className="space-y-3">
                            {[
                                ["Instagram", "https://www.instagram.com/fgmapparel/"],
                                ["TikTok", "https://www.tiktok.com/@fgmapparel?lang=en"],
                                ["Facebook", "https://www.facebook.com/profile.php?id=100090863986985"],
                            ].map(([label, href]) => (
                                <li key={label}>
                                    <a
                                        href={href}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`footer-social-${label.toLowerCase().replace(/\W+/g, "-")}`}
                                        className="nav-link"
                                    >
                                        {label} ↗
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Massive wordmark */}
                <div
                    data-testid="footer-wordmark"
                    className="font-display font-outline-strong uppercase leading-none tracking-tight text-[18vw] md:text-[15rem] select-none pointer-events-none"
                >
                    FGM APPAREL
                </div>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/10 mt-8">
                    <div className="text-xs font-display tracking-[0.3em] text-zinc-500 uppercase">
                        © {year} FGM Apparel · All Rights Reserved
                    </div>
                    <div className="text-xs font-display tracking-[0.3em] text-zinc-500 uppercase flex items-center gap-3">
                        <span className="text-[#E63946]">Focus.</span>
                        <span className="text-white">Grind.</span>
                        <span className="text-[#1D4ED8]">Motivate.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
